module.exports = __webpack_public_path__ + "images/9c7e71d657976e2bd6048aa07d963a95-logo.png";